'use client';

import type { CoreUser } from '@/components/payouts/types/coreTypes';
import { useLegacyServerData } from '@/components/providers/LegacyServerDataProvider';
import { Nullable } from '@/components/types';
import React, { useContext, useState } from 'react';

export type ChangePayoutMethodModalContextData = {
  country: string;
  currency: string;
  user: CoreUser;
  eventVaultId: string;
  setEventVaultId: Function;
  eventEndDate: string;
};

export type ChangePayoutMethodModalContextProviderProps = {
  children: React.ReactNode;
};

export const ChangePayoutMethodModalContext =
  React.createContext<Nullable<ChangePayoutMethodModalContextData>>(null);

export const ChangePayoutMethodModalContextProvider: React.FC<
  ChangePayoutMethodModalContextProviderProps
> = ({ children }) => {
  const legacyServerData = useLegacyServerData();

  const [eventVaultId, setEventVaultId] = useState('');

  const value = {
    country: legacyServerData?.eventStatusData?.country ?? 'US',
    currency: legacyServerData?.eventStatusData?.currency ?? 'USD',
    user: legacyServerData?.user as CoreUser,
    eventEndDate: legacyServerData?.eventStatusData?.end ?? '',
    eventVaultId,
    setEventVaultId,
  };
  return (
    <ChangePayoutMethodModalContext.Provider value={value}>
      {children}
    </ChangePayoutMethodModalContext.Provider>
  );
};

export const useChangePayoutMethodModalContext = () => {
  return useContext(ChangePayoutMethodModalContext) as ChangePayoutMethodModalContextData;
};
